import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {Banner, BannerFlexWrapper, BannerTextWrapper} from '../../../../Banner';

type EditArtifactTTLSummaryProps = {
  artifactAgeDays: number;
  ttlRemainingDays: number;
};

export const EditArtifactTTLSummary = ({
  artifactAgeDays,
  ttlRemainingDays,
}: EditArtifactTTLSummaryProps) => {
  return (
    <Tailwind style={{width: '100%'}}>
      <div className="min-h-130 flex flex-row gap-8">
        <div className="mr-8 w-4 rounded bg-teal-450" />
        <div className="flex w-full flex-col gap-8">
          <div className="border-1 m-h-65 flex w-full flex-row rounded border border-solid border-moon-250 px-12 py-8">
            <div className="mr-8 self-center p-10">
              <Icon name="versions-layers" />
            </div>
            <div className="flex-col">
              <div className="text-base font-semibold text-moon-450">
                Artifact age
              </div>
              <div className="text-base font-normal">
                {Math.round(artifactAgeDays)} days
              </div>
            </div>
          </div>
          <div className="border-1 m-h-65 flex w-full flex-row rounded border border-solid border-moon-250 px-12 py-8">
            <div className="mr-8 self-center p-10">
              <Icon
                name="recent-clock"
                className={ttlRemainingDays <= 0 ? 'text-red-550' : ''}
              />
            </div>
            <div className="flex-col">
              <div className="text-base font-semibold text-moon-450">
                TTL remaining
              </div>
              <div
                className={
                  ttlRemainingDays <= 0
                    ? 'text-base font-semibold text-red-550'
                    : 'text-base font-semibold'
                }>
                {ttlRemainingDays < 1 && ttlRemainingDays > 0
                  ? 'less than a day'
                  : ttlRemainingDays <= 0 && ttlRemainingDays > -1
                    ? 'less than a day past due'
                    : ttlRemainingDays <= 0
                      ? Math.abs(Math.round(ttlRemainingDays)) +
                        ' days past due'
                      : Math.round(ttlRemainingDays) + ' days'}
              </div>
            </div>
          </div>
        </div>
      </div>

      {ttlRemainingDays <= 0 && (
        <Banner variant="error" className="mt-24">
          <BannerFlexWrapper>
            <Icon name="warning-alt" style={{flex: 'none'}} />
            <BannerTextWrapper>
              <div>
                <div className="inline-block font-semibold">Caution:</div>
                &nbsp; The Time to Live (TTL) duration you've specified is less
                than the actual age of this artifact. Setting a TTL shorter than
                the artifact's age will result in immediate deletion of the
                version.
              </div>
            </BannerTextWrapper>
          </BannerFlexWrapper>
        </Banner>
      )}
    </Tailwind>
  );
};
